<template>
  <ubi-page-container>
        <template v-slot:page-actions>
          <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" class="inline" v-loading="loadingExport" @click="exporter">
                    {{ $t("portals.report.exportResults") }}
          </el-button>
        </template>
      <div v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
        <ubi-panel :title="$t('contacts.contactGenere')" size="sm">
          <el-row>
            <el-col :lg="24" :md="12">
              <el-row>
                <el-col :lg="12" class="mb-3">
                  <el-row>
                      {{ $t("contacts.listGeneratedEmailContactsTotal") }}
                      <el-tooltip placement="top-start" :content="$t('contacts.listTooltipTotal')">
                          <em class="el-icon-question"></em>
                      </el-tooltip>
                      <span>&nbsp;</span><strong>{{ nbContactsGeneresTotal }}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.listGeneratedContactsAds") }} <strong>{{ nbContactsGeneres }}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.listGeneratedCallContactsTotal") }}
                    <el-tooltip placement="top-start" :content="$t('contacts.listTooltipTotal')">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                    <span>&nbsp;</span><strong>{{ nbContactsCall }}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>
                      {{ $t("contacts.listActivePortals") }}
                      <strong>{{ nbPortailsActifs }}</strong>
                  </el-row>
                  <el-col> <br></el-col>
                  <el-row>
                      {{ $t("contacts.listAdsSent") }}
                      <strong>{{ nbAnnonces }}</strong>
                  </el-row>
                </el-col>
                <el-col :lg="12">
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
              </el-col>
              </el-row>

            </el-col>
          </el-row>
        </ubi-panel>

        <el-form @submit.prevent.native="fetchList">
          <ubi-panel style="background-color: #EBF3F2;">
            <ubi-search-container
            :filters="filters"
            @filter="doFilter"
            :defaultFilter="this.filter.presetPosts"
            v-on:resetfilter="doFilter('reset')"
            :more-opened="filter.advanced"
            @update:more-opened="advanced => setFilter({ advanced })">
              <el-form-item :label="$t('general.filters.referenceContactEmail')">
                <el-input type="text" @input="setSearch" :value="filter.search" :placeholder="$t('general.filters.adReferencePlaceholder')" />
              </el-form-item>
              <el-form-item :label="$t('general.filters.date')">
                  <el-date-picker
                          type="daterange"
                          :value="filter.beforeContacts || filter.afterContacts? [filter.beforeContacts || undefined, filter.afterContacts || undefined] : null"
                          :start-placeholder="$t('general.filters.dateCreationStart')"
                          :end-placeholder="$t('general.filters.dateCreationEnd')"
                          @input="
                    dates => addFilter({ beforeContacts: dates? dates[0] : null, afterContacts: dates ? dates[1] : null})
                  "
                          format="dd/MM/yyyy"
                          :picker-options="pickerOptions"
                  ></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('general.filters.negociateur')" v-if="filtreNegociateur()">
                <el-select
                    v-model="filter.negociateur"
                    @input="negociateur => addFilter({ negociateur })"
                    :placeholder="$t('general.filters.negociateurPlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      v-for="negociateur in negociateurs"
                      :key="negociateur.id"
                      :label="negociateur.nom + ' ' + negociateur.prenom"
                      :value="negociateur.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </ubi-search-container>
          </ubi-panel>
        </el-form>
        <ubi-panel>
            <ubi-list-header slot="header"
            :key="'header-' + paginationKey"
            :limits="limits"
            :page.sync="page"
            :limit.sync="limit"
            :total="nbResults"
            :sort.sync="sort"
            :sortProperties="sortProperties"></ubi-list-header>

            <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" type="mini" slot="actions" v-loading="loadingExport" @click="exporter">
                {{ $t("contacts.exportResults") }}
            </el-button>
            <ubi-list-footer slot="footer"  :key="'footer-' + paginationKey" :limits="limits" :page.sync="page" :limit.sync="limit" :total="nbResults"></ubi-list-footer>

            <el-table ref="table" :data="results.contact_mailtracking">
              <el-table-column type="expand">
                <template v-slot="{ row: result }">
                  {{ result.commentaire }}
                  <div>
                    <div v-if="result.codePostal">{{ $t("contacts.listTabMailtrackingPostalCode") }} :  {{ result.codePostal }}</div>
                    <div v-else>{{ $t("contacts.listTabMailtrackingPostalCode") }} : {{ $t("contacts.listTabMailtrackingNoInformation") }}</div>
                  </div>
                  <div>
                    <div v-if="result.ville">{{ $t("contacts.listTabMailtrackingCity") }} :  {{ result.ville }}</div>
                    <div v-else>{{ $t("contacts.listTabMailtrackingCity") }} : {{ $t("contacts.listTabMailtrackingNoInformation") }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  width="100">
                <template v-slot:header>
                  <sortable-column-header
                      field="dateEnvoi"
                      :label="$t('contacts.listColumnDate')"
                      :currentSort="columnSort"
                      default-direction="desc"
                      :default-active="isActiveDefault('dateEnvoi')"
                      @sort="handleColumnSort"
                  />
                </template>
                <template v-slot="{ row: result }">
                  {{ (new Date(result.dateEnvoi)).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column width="140">
                <template v-slot:header>
                  <sortable-column-header
                      field="reference"
                      :label="$t('contacts.listColumnReference')"
                      :currentSort="columnSort"
                      default-direction="desc"
                      :default-active="isActiveDefault('reference')"
                      @sort="handleColumnSort"
                  />
                </template>
                <template v-slot="{ row: result }">
                  {{ result.reference }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnLogo')"  min-width="120">
                <template v-slot="{ row: result }">
                  <img
                      alt=""
                      width="70"
                      :src="`${sitimmoUrl}/images/logos/diffuseur/${result.idDiffuseur}.jpg`"
                      :srcset="`${sitimmoUrl}/images/logos/diffuseur/${result.idDiffuseur}.jpg`"
                  />
                </template>
              </el-table-column>
              <el-table-column width="170">
                <template v-slot:header>
                  <sortable-column-header
                      field="nomPortail"
                      :label="$t('contacts.listColumnPortal')"
                      :currentSort="columnSort"
                      default-direction="desc"
                      :default-active="isActiveDefault('nomPortail')"
                      @sort="handleColumnSort"
                  />
                </template>
                <template v-slot="{ row: result }">
                  {{ result.nomDiffuseur }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnCivilityLastnameFirstname')"  width="200">
                <template v-slot="{ row: result }">
                  {{ result.identite }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnEmail')"  width="230">
                <template v-slot="{ row: result }">
                  {{ result.email }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnPhoneNumber')"  width="120">
                <template v-slot="{ row: result }">
                  {{ result.telephone }}
                </template>
              </el-table-column>
            </el-table>
        </ubi-panel>
      </div>
  </ubi-page-container>
</template>

<style lang="scss">
  @import "@/theme/_bootstrap.scss";
  .el-loading-spinner {
      top:10%!important;
  }
</style>

<script>
import moment from 'moment'
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  exportContacts,
  getContactsAll,
  getContactsStatsEnTete,
  getNbCalls,
  orderNbCalls
} from '@/services/contacts'
import downloadexcel from 'vue-json-excel'
import { getNegociateurs } from '@/services/negociateurs'
import SortableColumnHeader from '@/components/filters/SortableColumnHeader.vue'

export default {
  name: 'ContactsListAll',
  inject: ['browserContext'],
  components: {
    SortableColumnHeader,
    downloadexcel
  },
  data () {
    return {
      loading: false,
      loadingExport: false,
      offset: 0,
      limits: [10, 10 * 2, 10 * 5],
      enTete: null,
      nbResults: 0,
      tagPostSize: 'mini',
      sortProperties: {
        date: this.$t('general.sort.date'),
        reference: this.$t('general.sort.reference'),
        nomPortail: this.$t('general.sort.portalName')
      },
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbContactsCall: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      nbPortailsActifs: 0,
      contacts: null,
      graphData: {},
      annoncesStats: {},
      filters: [],
      sitimmoUrl: processEnvConfig.VUE_APP_SITIMMO_URL,
      negociateurs: [],
      columnSort: { field: null, direction: null }, // Pour le tri par colonne
      initialFetchDone: false,
      paginationKey: 0
    }
  },
  computed: {
    ...mapState('contactsList', ['filter', 'results']),
    ...mapGetters(['isSubUser', 'getPickerOptionsShortcuts']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    page: {
      get () {
        return Number(this.filter.page)
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    }
  },
  beforeMount () {
    this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
    if (this.filtreNegociateur()) {
      this.callNegociateurs()
    }
  },
  mounted () {
    this.filter.sort = 'date'
    this.filter.direction = 'desc'
    this.fetchList()
  },
  methods: {
    isActiveDefault (field) {
      if (!this.initialFetchDone) {
        return field === 'dateEnvoi'
      }
      return false
    },
    handleColumnSort ({ field, direction }) {
      this.columnSort = { field, direction }
      console.log(field, direction)
      if (field === 'dateEnvoi') {
        this.filter.sort = 'date'
        this.filter.direction = direction
      }
      if (field === 'reference') {
        this.filter.sort = 'reference'
        this.filter.direction = direction
      }
      if (field === 'nomPortail') {
        this.filter.sort = 'nomPortail'
        this.filter.direction = direction
      }
      // Réinitialiser la pagination à la page 1
      this.setOffset(0);
      this.setPage(1);

      this.fetchList()
      console.log(this.filter)
    },
    eventAnalytics (category) {
      this.$ga.event('contact_manager_contacts', 'clic', category, this.sitimmoUser.id)
    },
    async exporter (event) {
      this.eventAnalytics('total_contact')
      this.loadingExport = true
      this.filter.exportType = 'contact_mailtracking'
      const res = await exportContacts(this.filter)
      this.loadingExport = false
      this.$message(res)
    },
    async getEnTete () {
      this.enTete = await (getContactsStatsEnTete(this.filter))
      if (this.enTete.type === 'error') {
        this.loading = false
        return false
      }
      // calltracking
      const nbCalls = await (getNbCalls(this.filter))
      const statsNbCalls = orderNbCalls(nbCalls)
      this.enTete.infos.nbContactsCall = statsNbCalls.TOTAL_CONTACTS_CALLTRACKING
    },
    ...mapMutations('contactsList', [
      'setPage',
      'setPage',
      'setOffsetPosts',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter',
      'setBeforeContacts',
      'setAfterContacts'
    ]),
    doFilter (type) {
      switch (type) {
        case 'reset':
          this.filter.search = ''
          this.filter.beforeContacts = moment().subtract(7, 'days')
          this.filter.afterContacts = moment()
          this.filter.activeOnly = null
          this.filter.sort = 'date'
          type = 'withContacts'
          this.setFilter(this.filter)
          break
      }
      this.filter.presetPosts = type
      this.fetchList()
    },
    async fetchList () {
      this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      this.loading = true
      this.nbResults = 0
      this.contacts = null
      await (this.getEnTete(this.filter))
      this.nbContactsGeneres = this.enTete.infos.nbContactsGeneres
      this.nbContactsGeneresTotal = this.enTete.infos.nbContactsGeneresTotal
      this.nbAnnonces = this.enTete.infos.nbAnnonces
      this.nbProspects = this.enTete.infos.nbProspects
      this.nbPortailsActifs = this.enTete.infos.nbPortailsActifs
      this.annoncesStats = this.enTete.infos.infosAnnonces
      this.nbContactsCall = this.enTete.infos.nbContactsCall

      const contacts = await getContactsAll(this.filter)
      if (contacts.type === 'error') {
        this.loading = false
        return false
      }
      this.setResults(contacts)
      if (this.results.contact_mailtracking) {
        this.nbResults = this.results.total_items
        this.contacts = this.results.contact_mailtracking
      }
      this.setPage(this.results.page)
      this.paginationKey++
      this.loading = false
    },
    async callNegociateurs () {
      this.filter.negociateur = null
      this.filter.reseau = 'EXP FRANCE'
      this.negociateurs = await getNegociateurs(this.filter)
    },
    filtreNegociateur () {
      return ((this.sitimmoUser.id == 342878) || this.sitimmoUser.betaTesteur)
    }
  }
}
</script>
